import React from "react";
import Label from "../Label";
import { Control, useController } from "react-hook-form";
import DirectoryPicker, {
  DirectoryPickerProps,
} from "../../../../components/shared/DirectoryPicker";
import Hint from "../../fields/Hint";
import { MultiValue, SingleValue } from "react-select";
import { ValueType } from "../../DirectoryPicker/types";
import classNames from "classnames";

type InputArgs = {
  name: string;
  control?: Control<any>;
  label?: string;
  hint?: string;
  required?: string | boolean;
  placeholder?: string;
  multi?: boolean;
  maxLength?: number;
  defaultValue?: string;
  apiToValues?: (
    apiValues: any,
  ) => MultiValue<ValueType> | SingleValue<ValueType>;
  valuesToApi?: (
    formValues: MultiValue<ValueType> | SingleValue<ValueType>,
  ) => any;
  children?: React.ReactNode;
  containerClassName?: string;
  childClassName?: string;
};

export default function DirectoryPickerInput({
  label,
  control,
  name,
  hint,
  required = false,
  defaultValue,
  apiToValues,
  valuesToApi,
  children,
  containerClassName,
  childClassName,
  ...directoryPickerProps
}: InputArgs & DirectoryPickerProps) {
  const {
    field,
    fieldState: { invalid, error },
  } = useController({
    name,
    rules: { required },
    defaultValue,
    control,
  });

  return (
    <div className={classNames("control-group", containerClassName)}>
      {label && <Label label={label} required={!!required} />}
      <div
        className={classNames(
          "controls",
          {
            "border-box p-3": !!children,
            "field-error field-error-live": invalid,
          },
          childClassName,
        )}
      >
        <DirectoryPicker
          {...directoryPickerProps}
          {...field}
          value={apiToValues ? apiToValues(field.value) : field.value}
          onChange={(values) =>
            field.onChange(valuesToApi ? valuesToApi(values) : values)
          }
        />
        {hint && <Hint hint={hint} />}
        {/* validation message (rule or server-side via setError) — the red
            border alone does not tell why the selection was rejected */}
        {error?.message && (
          <div className="text-sm text-danger mt-1">{error.message}</div>
        )}
        {children}
      </div>
    </div>
  );
}
